import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import {
  CategoryDetailInterface,
  CategoryFormInterface
} from '../../interfaces/category'
import CategoryFormHandlerBar from './CategoryFormHandlerBar'
import CategoryFormMainBody from './CategoryFormMainBody'

const CategoryForm = ({
  categoryDetail,
  formHandlers,
  newForm
}: {
  categoryDetail: CategoryDetailInterface
  formHandlers: {
    createCategory: (createdCategory: CategoryFormInterface) => void
    updateCategory: (updatedCategory: CategoryFormInterface) => void
  }
  newForm: boolean
}) => {
  const methods = useForm<CategoryFormInterface>({
    defaultValues: {
      ...categoryDetail
    }
  })
  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <form>
        <CategoryFormHandlerBar
          saveHandler={handleSubmit(formHandlers.updateCategory)}
          createHandler={handleSubmit(formHandlers.createCategory)}
          newForm={newForm}
        />
        <CategoryFormMainBody categoryDetail={categoryDetail} />
      </form>
    </FormProvider>
  )
}

export default CategoryForm
